import {
  FIND_MAIL_FAILED,
  FIND_MAIL_SUCCESS,
  FORGOT_FAILED,
  FORGOT_LOADING,
  FORGOT_SUCCESS,
} from "../constants";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getRequestAuthenticationRequest,
  postRequest,
} from "../../../services/apiManager/apiRequests";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const findByEmailRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FORGOT_LOADING,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.findByEmail,
        params,
      );
      enqueueSnackbar(response?.userEmail, { variant: "success" });
      if (response?.userId) {
        dispatch({
          type: FIND_MAIL_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: FIND_MAIL_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: FIND_MAIL_FAILED,
        payload: {},
      });
    }
  };

export const sendEmailForgotPassword =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FORGOT_LOADING,
        payload: { isLoading: true },
      });
      const response = await postRequest(
        apiConfig.sendEmailForgotPassword,
        params,
      );
      enqueueSnackbar(response?.message, {
        variant: "success",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      if (response?.user) {
        dispatch({
          type: FIND_MAIL_SUCCESS,
          payload: response?.user,
        });
        callback(response);
      } else {
        dispatch({
          type: FIND_MAIL_FAILED,
          payload: {},
        });
        enqueueSnackbar(response?.message, {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      callback(error?.response?.data);
      enqueueSnackbar(error?.response?.data?.errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      dispatch({
        type: FIND_MAIL_FAILED,
        payload: {},
      });
    }
  };

export const forgotPasswordRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FORGOT_LOADING,
        payload: { isLoading: true },
      });
      const response = await postRequest(apiConfig.forgotPassword, params);
      enqueueSnackbar(response?.message, {
        variant: "success",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      if (response) {
        dispatch({
          type: FORGOT_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: FORGOT_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback(error?.response?.data);
      if (error?.response?.data?.error_description) {
        enqueueSnackbar("Failed to reset password", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      } else {
        enqueueSnackbar(error?.response?.data?.message, {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: FORGOT_FAILED,
        payload: {},
      });
    }
  };
